<div class="grow">
  <mat-table [dataSource]="vm()?.loading ? [] : vm()?.items" class="missions-table kp-card-table">
    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef class="text-xs font-bold min-w-[110px] max-w-[110px]">
        {{ 'UI.ACTIVITY_LOG.DATE' | transloco }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="min-w-[110px] max-w-[110px]">
        {{ element?.date | date: 'shortDate' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="time">
      <mat-header-cell *matHeaderCellDef class="text-xs font-bold min-w-[90px] max-w-[90px]">
        {{ 'UI.ACTIVITY_LOG.COLUMNS.TIME' | transloco }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="min-w-[90px] max-w-[90px]">
        {{ element?.time }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="user">
      <mat-header-cell *matHeaderCellDef class="text-xs font-bold min-w-[150px] max-w-[400px]">
        {{ 'UI.ACTIVITY_LOG.USER' | transloco }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="min-w-[150px] max-w-[400px]">
        <span class="break-words line-clamp-3">
          {{ element?.user }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef class="text-xs font-bold min-w-[100px]">
        {{ 'UI.ACTIVITY_LOG.ACTION' | transloco }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="min-w-[100px]">
        <span class="break-words line-clamp-3">
          {{
            'UI.ACTIVITY_LOG.COLUMNS.ACTION_DESCRIPTION.' + element?.action
              | kpPluralizeTranslate: element?.actionParams
          }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef class="text-xs font-bold min-w-[170px] max-w-[170px]">
        {{ 'UI.GENERAL.STATUS' | transloco }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="min-w-[170px] max-w-[170px]">
        <span class="break-words line-clamp-3">
          <kp-card-tag
            [label]="'UI.ACTIVITY_LOG.STATUS.' + element?.status | transloco | uppercase"
            [dotColor]="statusTagColor[element?.status]"
            [keepOpen]="true"
          ></kp-card-tag>
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="menu">
      <mat-header-cell *matHeaderCellDef class="min-w-[80px] max-w-[80px]"> </mat-header-cell>
      <mat-cell *matCellDef="let element" class="min-w-[80px] max-w-[80px]">
        <button mat-icon-button (click)="onExport(element?.id)">
          <mat-icon class="s-6">download</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" class="h-[88px]"></mat-row>
  </mat-table>

  @if (vm()?.loading) {
    <ngx-skeleton-loader count="3" animation="pulse" [theme]="itemsLoaderTheme"></ngx-skeleton-loader>
  }
</div>

<mat-paginator
  [length]="vm()?.pagination.totalItems"
  [pageSize]="vm()?.pagination.perPage"
  [pageIndex]="vm()?.pagination.currentPage"
  [pageSizeOptions]="PAGE_SIZE_OPTIONS"
  [showFirstLastButtons]="true"
  (page)="onPageChange($event)"
  class="border-t-1 border-slate-200 dark:border-neutral-600 w-full sticky bottom-0"
>
</mat-paginator>
